var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4031 3.20959V6.69347C15.4031 7.33483 15.9231 7.85476 16.5644 7.85476H20.0483M9.01605 7.85476H11.3386M9.01605 11.3386H15.9838M9.01605 14.8225H15.9838M18.3064 4.95153C17.7895 4.48909 17.2532 3.94061 16.9146 3.58438C16.6893 3.34734 16.378 3.20959 16.051 3.20959H7.27384C5.99112 3.20959 4.95127 4.24944 4.95126 5.53216L4.95117 19.4676C4.95116 20.7503 5.99101 21.7902 7.27374 21.7902L17.7254 21.7902C19.0081 21.7902 20.048 20.7504 20.048 19.4677L20.0483 7.15588C20.0483 6.85894 19.935 6.5735 19.7289 6.35972C19.3478 5.96441 18.7114 5.31397 18.3064 4.95153Z",
    stroke: "#1B4DFF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile05);
export default __webpack_public_path__ + "static/media/file-05.655aef5b04cb8e27651ea01fe1e15cb1.svg";
export { ForwardRef as ReactComponent };